import { render, staticRenderFns } from "./RepairDetails.vue?vue&type=template&id=45a12f6a&scoped=true&"
import script from "./RepairDetails.vue?vue&type=script&lang=js&"
export * from "./RepairDetails.vue?vue&type=script&lang=js&"
import style0 from "./RepairDetails.vue?vue&type=style&index=0&id=45a12f6a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a12f6a",
  null
  
)

export default component.exports